import { PawPrint } from "lucide-react";
import { MUNICIPIOS } from "../data/content";
import { useLang } from "../i18n";

const Marquee = () => {
    const { t } = useLang();
    const items = ["Maresme Dog Care", ...MUNICIPIOS, t.marquee.b];

    const Strip = () => (
        <div className="flex shrink-0 items-center">
            {items.map((item, i) => (
                <span key={i} className="flex items-center">
                    <span className={`whitespace-nowrap px-6 text-sm font-semibold tracking-wide sm:text-base ${i === 0 || i === items.length - 1 ? "font-serif text-lg italic sm:text-xl" : ""}`}>
                        {item}
                    </span>
                    <PawPrint size={14} className="shrink-0 opacity-50" aria-hidden="true" />
                </span>
            ))}
        </div>
    );

    return (
        <div
            data-testid="editorial-marquee"
            aria-hidden="true"
            className="overflow-hidden border-y border-olive-dark/20 bg-olive py-4 text-cream"
        >
            <div className="marquee-track">
                <Strip />
                <Strip />
            </div>
        </div>
    );
};

export default Marquee;
